import React, { useEffect, useState } from "react";
import "./App.css";
import OAAddOnMain from "./OAAddOnMain";
import Tools from "./JNSTools";
import { LicenseInfo } from "@mui/x-license-pro";
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import * as Ably from "ably";
import { AblyProvider, ChannelProvider } from "ably/react";
import "../node_modules/@syncfusion/ej2-base/styles/material.css";
import "../node_modules/@syncfusion/ej2-buttons/styles/material.css";
import "../node_modules/@syncfusion/ej2-calendars/styles/material.css";
import "../node_modules/@syncfusion/ej2-dropdowns/styles/material.css";
import "../node_modules/@syncfusion/ej2-gantt/styles/material.css";
import "../node_modules/@syncfusion/ej2-grids/styles/material.css";
import "../node_modules/@syncfusion/ej2-inputs/styles/material.css";
import "../node_modules/@syncfusion/ej2-layouts/styles/material.css";
import "../node_modules/@syncfusion/ej2-lists/styles/material.css";
import "../node_modules/@syncfusion/ej2-navigations/styles/material.css";
import "../node_modules/@syncfusion/ej2-popups/styles/material.css";
import "../node_modules/@syncfusion/ej2-richtexteditor/styles/material.css";
import "../node_modules/@syncfusion/ej2-treegrid/styles/material.css";
import "../node_modules/@syncfusion/ej2-react-interactive-chat/styles/material.css";
import "../node_modules/@syncfusion/ej2-interactive-chat/styles/material.css";

import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

import "./fonts/Bell MT.ttf";

import { registerLicense } from "@syncfusion/ej2-base";
function App_v2() {
  LicenseInfo.setLicenseKey(
    "2858a57c2db5d11fbddf8de9000d15aaTz03ODQxOSxFPTE3MzExOTI5MTQwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=",
  );
  // Registering Syncfusion license key -- updated 2024-10-27
  registerLicense(
    "ORg4AjUWIQA/Gnt2UlhhQlVMfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX9TdEJhWH1YcnJVRmFU",
  );
  //registerLicense(
  //  "ORg4AjUWIQA/Gnt2U1hhQlJBfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5Vd0ZjUXpYc3BcQ2hY",
  //);
  //registerLicense(
  //  "ORg4AjUWIQA/Gnt2UVhhQlVFfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5Rd0xjUXpfcXNSRWNV",
  //);
  // Original Syncfusion License Key
  // ORg4AjUWIQA/Gnt2VlhhQlJCfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hSn9Sd0NjXntWc3JTQGhf
  // v 24.1.41
  // ORg4AjUWIQA/Gnt2UVhhQlVFfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5Rd0xjUXpfcXNSRWNV
  // v 26.x.x
  // ORg4AjUWIQA/Gnt2U1hhQlJBfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5Vd0ZjUXpYc3BcQ2hY

  //const toggleWait = () => setWait(!wait);

  const [displayPage, setDisplayPage] = useState();

  //localStorage.removeItem("instanceInfo");
  sessionStorage.setItem("helpmode", false);
  sessionStorage.setItem("persistenceKey", new Date().getTime().toString());

  useEffect(() => {
    const handleBeforeUnload = async (event) => {
      const projectObject = sessionStorage.getItem("projectObject");
      if (projectObject) {
        sessionStorage.setItem(
          "refreshProjectId",
          JSON.parse(projectObject).id,
        );
      }
      localStorage.setItem("lastUnloadTime", new Date().getTime());
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener(
      "popstate",
      function (event) {
        // The popstate event is fired each time when the current history entry changes.

        var r = confirm(
          "CollabCenter is a single page application.  By clicking the back button you will leave CollabCenter.  Click OK if you want to do this, or Cancel if not.",
        );

        if (r == true) {
          // Call Back button programmatically as per user confirmation.
          //history.back();
          // Uncomment below line to redirect to the previous page instead.
          window.location = document.referrer; // Note: IE11 is not supporting this.
        } else {
          // Stay on the current page.
          history.pushState(null, null, window.location.pathname);
        }

        history.pushState(null, null, window.location.pathname);
      },
      false,
    );

    history.pushState(null, null, window.location.pathname);

    const lastUnloadTime = parseInt(localStorage.getItem("lastUnloadTime"));
    if (lastUnloadTime) {
      const currentTime = new Date().getTime();
      if (currentTime - lastUnloadTime > 10000) {
        // if browser unloaded within 10 seconds of new load, will bring up previous tab, otherwise requires new login
        //sessionStorage.removeItem("currentTab"); <-- uncommenting this will cause Duplicate Tab to require a new login also
        sessionStorage.removeItem("tabHistory");
      }
    }

    const ablyClient = new Ably.Realtime({
      key: "OJnrHg.9Ln1tQ:l7wgdVgvVeH5L7D-atBgoLf4eLU9jbiFAQEIGqOSV4k",
    });

    const originalProjectId = sessionStorage.getItem("refreshProjectId");
    const originalCreds = localStorage.getItem("instanceInfo");
    if (originalProjectId && originalCreds) {
      localStorage.removeItem("refreshProjectId");
      const creds =
        originalCreds.indexOf("company") == -1
          ? JSON.parse(Tools.decrypt(originalCreds))
          : JSON.parse(originalCreds);
      const authString = Tools.getXmlBodyAuthString(creds);
      const urlString = Tools.getInstanceUrl(creds);
      const requestString =
        authString +
        '<Read type="Project" method="equal to" limit="1" enable_custom="1"><Project><id>' +
        originalProjectId +
        "</id></Project></Read></request>";
      Tools.fetchPost(requestString, urlString, "Project").then(
        (projRecRaw) => {
          if (projRecRaw.xml && projRecRaw.xml.length > 0) {
            const projRec = Tools.xmlToArray(projRecRaw.xml);
            sessionStorage.setItem("projectObject", JSON.stringify(projRec[0]));
          }
          setDisplayPage(
            <AblyProvider client={ablyClient}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <OAAddOnMain />
              </LocalizationProvider>
            </AblyProvider>,
          );
        },
      );
    } else {
      setDisplayPage(
        <AblyProvider client={ablyClient}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <OAAddOnMain />
          </LocalizationProvider>
        </AblyProvider>,
      );
    }

    /*return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };*/
  }, []);

  return displayPage;
}

export default App_v2;
